import { render, staticRenderFns } from "./ViewEditPanel.vue?vue&type=template&id=0405fa84&scoped=true&"
import script from "./ViewEditPanel.vue?vue&type=script&lang=js&"
export * from "./ViewEditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405fa84",
  null
  
)

export default component.exports